// extracted by mini-css-extract-plugin
export var active = "Industries-module--active--4c682";
export var cardsTrack = "Industries-module--cardsTrack--dfdb0";
export var cardsWrapper = "Industries-module--cardsWrapper--49b41";
export var defaultWidth = "Industries-module--defaultWidth--539f0";
export var fadeInAnimation = "Industries-module--fadeInAnimation--d57c4";
export var hidden = "Industries-module--hidden--e0114";
export var mediumWidth = "Industries-module--mediumWidth--00f2c";
export var navArrow = "Industries-module--navArrow--24f33";
export var next = "Industries-module--next--48b82";
export var pagination = "Industries-module--pagination--3d565";
export var paginationButton = "Industries-module--paginationButton--10ba1";
export var prev = "Industries-module--prev--cbf2d";
export var sliderWrapper = "Industries-module--sliderWrapper--51b58";
export var smallWidth = "Industries-module--smallWidth--04ce6";
export var subtitle = "Industries-module--subtitle--46657";
export var withTransition = "Industries-module--withTransition--7c25a";
export var wrapper = "Industries-module--wrapper--03e0c";